import React, { useState } from "react";

import api from "../services/api";

export default function ManuelSwitcher({ manuels = [] }) {
  const [open, setOpen] = useState(false);
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState("");

  const choisir = async (manuel) => {
    if (!manuel.owned || manuel.active || busyId) return;
    setBusyId(manuel.id);
    setError("");
    try {
      const { data } = await api.post("manuels/actif/", { manuel_id: manuel.id });
      localStorage.setItem("access_token", data.access);
      localStorage.setItem("refresh_token", data.refresh);
      window.location.reload();
    } catch (requestError) {
      setError(requestError?.response?.data?.detail || "Impossible de changer de manuel.");
      setBusyId(null);
    }
  };

  if (manuels.length < 2) return null;

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-outline-primary ql-manuel-switch-btn"
        onClick={(event) => { event.stopPropagation(); setOpen(true); }}
      >
        <i className="bi bi-arrow-left-right me-1"></i>Changer de manuel
      </button>
      {open && (
        <div className="ql-modal-overlay" role="dialog" aria-modal="true" aria-label="Choisir un manuel" onClick={() => setOpen(false)}>
          <div className="ql-manuel-switch-modal" onClick={(event) => event.stopPropagation()}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold mb-0">Choisir un manuel</h5>
              <button type="button" className="btn-close" aria-label="Fermer" onClick={() => setOpen(false)}></button>
            </div>
            {error && <div className="alert alert-danger py-2">{error}</div>}
            <div className="ql-manuel-switch-list">
              {manuels.map((manuel) => (
                <button
                  type="button"
                  key={manuel.id}
                  className={`ql-manuel-switch-item${manuel.active ? " is-active" : ""}${manuel.owned ? "" : " is-locked"}`}
                  disabled={!manuel.owned || busyId !== null}
                  onClick={() => choisir(manuel)}
                >
                  {manuel.image_url
                    ? <img src={manuel.image_url} alt="" />
                    : <span className="ql-manuel-switch-icon"><i className="bi bi-book-half"></i></span>}
                  <span className="ql-manuel-switch-text">
                    <strong>{manuel.title}</strong>
                    {manuel.level && <small>{manuel.level}</small>}
                    <small className="ql-manuel-switch-state">
                      {manuel.active ? "Manuel actuel" : manuel.owned ? (busyId === manuel.id ? "Ouverture…" : "Ouvrir ce manuel") : "Non activé — entre son code à la connexion"}
                    </small>
                  </span>
                  {!manuel.owned && <i className="bi bi-lock-fill ql-manuel-switch-lock"></i>}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
